import tableRooms from './tableRooms';
import tableYoutubeIteractables from './tableYoutubeIteractables';

export default {
  title: 'Youtube Interactables Management',
  attributeName: 'youtubeInteractables',
  getURL: 'mainHubs/mainHubId/youtube/interactables',
  createURL: 'mainHubs/mainHubId/youtube/interactables',
  updateURL: 'mainHubs/mainHubId/youtube/interactables',
  removeURL: 'mainHubs/mainHubId/youtube/interactables',
  sessionParams: ['mainHubId'],
  idAttribute: 'id',
  tableConfig: tableYoutubeIteractables,
  removeNameField:'name',
  removeText:'You are about to remove the interactable with name ##name##.',
  noArea: true,
  autoUpdate: true,
};

